import { forwardRef, useEffect } from 'react';
import { useAutoPlayVideo, useMorph } from '../model';

export const ScreenCast = forwardRef<HTMLVideoElement>((props, ref) => {
  const { bindEvents } = useMorph();
  const { autoplayAllowed } = useAutoPlayVideo();

  useEffect(() => {
    return bindEvents();
  }, []);

  return (
    <div
      className="ag-opacity-100 ag-absolute ag-border ag-backdrop-blur-[21.5px] ag-flex ag-flex-col ag-justify-center ag-duration-200 ag-items-center
        ag-top-3 ag-left-3 ag-right-auto ag-bottom-auto xl:ag-right-5 xl:ag-bottom-5 xl:ag-top-auto xl:ag-left-auto
        ag-rounded-xl ag-transition-all ag-overflow-hidden ag-w-[148px] ag-h-[92px] sm:ag-w-[238px] sm:ag-h-[132px] max-w-md mx-auto aspect-video border border-white"
    >
      <video
        ref={ref}
        autoPlay
        muted={autoplayAllowed}
        playsInline
        className="ag-h-full ag-w-full ag-object-cover"
        {...props}
      />
    </div>
  );
});
